// src/services/notificacaoAcademicaService.js
import api from '../services/api';

export const listarNotificacoes = async (usuarioId) => {
    return api.get(`/notificacoes-academicas/${usuarioId}`);
};

export const obterNotificacao = async (id) => {
    return api.get(`/notificacoes-academicas/detalhe/${id}`);
};

export const criarNotificacao = async (notificacao) => {
    return api.post('/notificacoes-academicas', notificacao);
};

export const marcarComoLida = async (id) => {
    return api.put(`/notificacoes-academicas/${id}/marcar-como-lida`);
};

export const excluirNotificacao = async (id) => {
    return api.delete(`/notificacoes-academicas/${id}`);
};